import { TStore } from "@components/types"
import { Atoms } from "@recoil/constants";
import { atom, selector } from "recoil";

const localStorage = typeof window !== `undefined` ? window.localStorage : null

export const internalSelectedStoreState = atom<TStore>({
    key: Atoms.InternalSelectedStore,
    default: localStorage?.getItem(Atoms.SelectedStore.toString()) === "undefined" ? {} : JSON.parse(localStorage?.getItem(Atoms.SelectedStore.toString()) || "{}"),
});

export const selectedStoreState = selector({
    key: Atoms.SelectedStore,
    get: ({ get }) => get(internalSelectedStoreState),
    set: ({ set }, newValue) => {
        set(internalSelectedStoreState, newValue);
        if (newValue !== undefined) {
            localStorage?.setItem(Atoms.SelectedStore.toString(), JSON.stringify(newValue));
        }
    },
});
